/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForServiceAccountDelete extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForServiceAccountDelete");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForServiceAccountDelete.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForServiceAccountDelete>): BackgroundJobPayloadForServiceAccountDelete {
        let obj = Object.assign(new BackgroundJobPayloadForServiceAccountDelete(), model);
        BackgroundJobPayloadForServiceAccountDelete.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForServiceAccountDelete>): BackgroundJobPayloadForServiceAccountDelete {
        if (!model) return null;
        return BackgroundJobPayloadForServiceAccountDelete.newInstance(<BackgroundJobPayloadForServiceAccountDelete> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForServiceAccountDelete) {
        if (!obj) return;

        models.BackgroundJobPayloadForServiceAccountDelete.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForServiceAccountDelete): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForServiceAccountDelete.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    service_account_id: string;

    user_id: string;

    is_onboarded: boolean;

}
